import { render, staticRenderFns } from "./product-details-add-to-cart.vue?vue&type=template&id=532f9efe&"
import script from "./product-details-add-to-cart.vue?vue&type=script&lang=js&"
export * from "./product-details-add-to-cart.vue?vue&type=script&lang=js&"
import style0 from "./product-details-add-to-cart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports